import * as ACTION_TYPES from '../types';

let initialState = {
  equipmentList: [],
  equipment: {},
  totalItems: Number
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_EQUIPMENTS:
        return {...state, equipmentList: action.data, totalItems: action.totalItems};

      case ACTION_TYPES.GET_EQUIPMENTS_BY_EQUIPMENTNO:
        return {...state, equipmentList: action.data };
        
      case ACTION_TYPES.GET_EQUIPMENTS_BY_SKNO:
        return {...state, equipmentList: action.data };

      case ACTION_TYPES.DELETE_EQUIPMENT:
        let newList = state.equipmentList.filter(equipment => equipment._id !== action.id);
        return {...state, equipmentList: newList };

      case ACTION_TYPES.GET_EQUIPMENT_BY_ID:
        return {...state, equipment: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_EQUIPMENTS:
        return {...state, equipmentList: []};

      default:
        return state;
    }
  };